module.exports = {
  context: {
    enabled: 1,
    key: 'abc123',
    expirationDate: 20210731,
    heading: 'New job openings',
    shortDescription: 'Careers with purpose: Adjoin is now accepting applications for job opportunities at our new Riverside location.',
    button: {
      text: 'Learn More',
      url: 'https://google.com',
      class: 'cta'
    }
  }
}
